module.exports = __webpack_public_path__ + "static/media/19068_1318010917072_2201101_n.adfcd6c7.jpg";